import { useEffect, useRef, useState, useLayoutEffect } from "react";
import { t } from 'i18next';
import Select, { StylesConfig } from 'react-select';
import { Dropdown } from 'react-bootstrap';
import Loader from '../../../common/Loader';
import GenerateInvoiceForm from "./GenerateInvoiceForm";
import TaskOffCanvas from '../../../common/OffCanvas';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { determineCommaSeprater, getPageSizeArray, paginationStyles, getFilteredList, sortData, getValueFromResource, FormatInvoiceDecimalNumber, validateCultureNumber, formatNumberCustomoriginal, getDecimalSeparator, parseLocalizedNumber } from '../../../common/timeLiveFunction';
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
    updateIsLoading, getInvoiceMasterandDetailRecordsList, addItemTimesheetBillingList, removeItemInTimesheetBilling, getAllDataInSingleRequestForInvoiceForm,
    updateAccountProjectTaskId, isEditableTimesheetList, isCancelTimesheetList, addItemExpenseBillingList, removeItemInExpenseBilling,
    isEditableExpenseList, isCancelExpenseList, updateTimesheetBillingValues, updateExpenseBillingValues, updateDiscountValues, updateMasterTimeExpenseBillingValues,
    updateAccountInvoice, updateAccountProjectTaskArray, updateProjectAndTaskInTimesheetList, updateProjectAndTaskInExpenseList, updateMasterTimeExpenseBillingValuesByClient,
    reCalculateInvoiceTotal, deleteTimesheetBillingList, deleteItemInTimesheetBilling, deleteItemInExpenseBilling, deleteExpenseBillingList, removeProjectAndTaskInBothList,
    updateTimeExpenseBillingIdForPrint, getAccountInvoiceTemplateByClientId, updateAccountTimeExpenseBillingId
} from "../invoiceBillingSlice";
import fetchAPI from "../../../common/fetchAPI";
import CustomPagination from "../../../common/Pagination";
import AccountInvoiceFormNavBar from "../AccountInvoiceFormNavBar";
import { ShowToast } from "../../../common/Toastr";
import InvoicePrintViewWidget from "./InvoicePrintViewWidget";
import {useNavigate } from "react-router-dom";
import PageSizeSelect from "../../../common/PageSizeSelect";

interface DropdownItem {
    value: number;
    label: string;
}

const objScroll = {
    clients: true,
    projects: true
}

const objPageSize = {
    timesheetPageSize: 10,
    expensePageSize: 10
}

const objCurrentPage = {
    timesheetCurrentPage: 1,
    expenseCurrentPage: 1
}

const objSearchTerm = {
    timesheetSearch: '',
    expenseSearch: ''
}

const objErrorValues = {
    isError: false,
    errorMessage: []
}

const objSortValues = {
    sortOrder: 'asc',
    sortColumn: 'ProjectName'
}

const AccountInvoiceForm = () => {
    const storageTimeExpenseBillingId = localStorage.getItem('storageTimeExpenseBillingId');
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [projectPage, setProjectPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState<string>('');
    const [projectSearch, setProjectSearch] = useState<string>('');
    const [hasMore, setHasMore] = useState(objScroll);
    const [dataClient, setDataClient] = useState<DropdownItem[]>([]);
    const [selectedClient, setSelectedClient] = useState<DropdownItem | null>(null);
    const [projectResponse, setProjectResponse] = useState<any | ''>([{ value: 0, label: 'None' }]);
    const { cultureInfoName, decimalPlaces, maxMenuHeight, invoiceFooter, sessionAccountId } = useAppSelector((state) => state.globalState);
    const { accountTimeExpenseBillingId, timesheetBillingList, accountTaxCodeList, accountExpenseNameList, accountExpenseTypeList, expenseBillingList,
        masterAccountTimeExpenseBilling, discountPercentage, isReload, isLoading, clientInvoiceFooter
    } = useAppSelector((state) => state.invoiceBilling);
    const [discountInput, setDiscountInput] = useState<string>("");
    const [searchTerm, setSearchTerm] = useState(objSearchTerm);
    const [pageSize, setPageSize] = useState(objPageSize);
    const [currentPage, setCurrentPage] = useState(objCurrentPage);
    const [setError, setErrorValues] = useState<any | ''>(objErrorValues);
    const [isFirstTimeCLoad, setIsFirstTimeCLoad] = useState(true);
    const [timesheetClientSideSorting, setTimesheetClientSideSorting] = useState<any | ''>(objSortValues);
    const [expenseClientSideSorting, setExpenseClientSideSorting] = useState<any | ''>(objSortValues);
    const getMasterRecord: any = masterAccountTimeExpenseBilling[0];
    const isCommaSeparator = determineCommaSeprater(cultureInfoName.toString());
    useEffect(() => {
    const master = masterAccountTimeExpenseBilling?.[0];
    if (master && master.DiscountPercentage !== null && master.DiscountPercentage !== undefined) {
        const formatted = FormatInvoiceDecimalNumber(
            cultureInfoName.toString(),
            Number(master.DiscountPercentage) || 0,
            2
        );
        setDiscountInput(formatted);
    } else {
        setDiscountInput(FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, 2));
    }
}, [masterAccountTimeExpenseBilling, cultureInfoName]);
    const modelRef = useRef<any>(null);
    // const scrollPosition = useRef(0);
    // const menuRef = useRef<HTMLDivElement | null>(null);
    let addInvoiceFooter;

    useLayoutEffect(() => {
        dispatch(updateAccountTimeExpenseBillingId(storageTimeExpenseBillingId));
    });
    useEffect(() => {
        dispatch((getAllDataInSingleRequestForInvoiceForm())).then((response) => {
            renderClients();
            if (storageTimeExpenseBillingId != '') {
                dispatch(getInvoiceMasterandDetailRecordsList()).then((result) => {
                    renderProjectsByClientId(1, projectSearch, result.payload.Data[0][0].AccountClientId);                    
                });
                // renderProjectsByClientId(1, projectSearch, getMasterRecord.AccountClientId).then((result) => {
                //     dispatch(getInvoiceMasterandDetailRecordsList())
                // });
            } else {
                dispatch(updateIsLoading(false));
            }
        });
    }, [storageTimeExpenseBillingId, isReload]);

    // useEffect(() => {
    //     renderClients(page, '').then((result) => {
    //         setIsFirstTimeCLoad(false);
    //     });
    // }, [page]);

    // const debouncedSearchTerm = useDebounce(search, 500);
    // useEffect(() => {
    //     if (!isFirstTimeCLoad) {
    //         search != "" && renderClients(page, search);
    //     }
    // }, [debouncedSearchTerm]);

    // useEffect(() => {
    //     if (menuRef.current) {
    //         menuRef.current.scrollTop = scrollPosition.current; // Restore scroll position
    //     }
    // }, [dataClient]);

    addInvoiceFooter = invoiceFooter.split('\n').map((item: any) => item.trim()).filter((item: any) => item !== '');

    // const renderClients = async (pageNum: any, search: string) => {
    const renderClients = async () => {
        setLoading(true);
        try {
            // const searchParam = search ? `&search=${search}` : "";
            // const response: any = await fetchAPI(`api/V2/Clients/Dropdown/0?page=${pageNum}${searchParam}`, "GET", "", true);
            const response: any = await fetchAPI(`api/V2/Clients/ClientDropdownForReact/${sessionAccountId}/0`, "GET", "", true);
            const json = await response.json();
            const transformedData = json.items.map((item: any) => ({
                value: item.id,
                label: item.text
            }));
            transformedData.unshift({ value: 0, label: 'Select' });
            const newItemsClients = transformedData.filter((item: any) => !dataClient.some((existingItem: any) => existingItem.value === item.value));
            setDataClient((prevData) => [...prevData, ...newItemsClients]);
            setSelectedClient(transformedData[0]);
            setHasMore({
                ...hasMore,
                clients: newItemsClients.length > 0 ? true : false
            })
        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const renderProjectsByClientId = async (pageNum: any, search: string, accountClientID: Number) => {
        try {
            // const searchParam = search != "" ? search : '';
            // const response: any = await fetchAPI(`api/V2/Projects/ByClientForDropdown/${accountClientID}/${0}/${pageNum}/${searchParam}`, "GET", "", true);
            const searchParam = search ? `&search=${search}` : "";
            const response: any = await fetchAPI(`api/V2/Projects/ByClientForDropdown/${accountClientID}/?AccountProjectId=${0}&page=${pageNum}${searchParam}`, "GET", "", true);
            const json = await response.json();;
            let transformedData = []
            if (json.Data.total_count > 0) {
                transformedData = json.Data.items.map((item: any) => ({
                    value: item.id,
                    label: item.text
                }));
            }
            transformedData.unshift({ value: 0, label: 'None' });
            setProjectResponse(transformedData);
            storageTimeExpenseBillingId === "" && dispatch(getAccountInvoiceTemplateByClientId(accountClientID));
        } catch (error) {
        } finally {
        }
    }

    const renderProjectTasksByProjectId = async (accountProjectId: number, index: number) => {
        try {
            // const response: any = await fetchAPI(`api/V2/Tasks/ProjectTasksForDropdown/${0}/${accountProjectId}/${1}`, "GET", "", true);
            const response: any = await fetchAPI(`api/V2/Tasks/ProjectTasksForDropdown/${0}/?AccountProjectId=${accountProjectId}&page=${1}`, "GET", "", true);
            const json = await response.json();
            const transformedData = json.Data.items.map((item: any) => ({
                value: item.id,
                label: item.text
            }));
            transformedData.unshift({ value: 0, label: 'None' });
            dispatch(updateAccountProjectTaskArray({ "index": index, "taskArray": transformedData }))
        } catch (error) {
        } finally {
        }
    }

    // const handleScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>, control: any) => {
    //     if (control === 'clientArray') {
    //         // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
    //         // if (bottom && hasMore.clients && !loading) {
    //         //     setPage((prevPage) => prevPage + 1);
    //         // }
    //         const target = e.target as HTMLDivElement;
    //         scrollPosition.current = target.scrollTop;
    //         if (hasMore.clients && !loading) {
    //             const bottom = target.scrollHeight === target.scrollTop + target.clientHeight;
    //             if (bottom) {
    //                 setPage((prevPage) => prevPage + 1);
    //             }
    //         }
    //     } else {
    //     }
    // }

    // const customMenuList = (props: any) => {
    //     const { children, innerRef, maxHeight } = props;
    //     const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
    //         handleScroll(e, props.selectProps.name);
    //     }
    //     return (
    //         <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
    //             {children}
    //         </div>
    //     )
    // }

    const handleChangeOption = (selected: any, control: any, index: number) => {
        if (control.name === "clientArray") {
            dispatch(updateMasterTimeExpenseBillingValuesByClient([{ "item": "AccountClientId", "value": selected.value }]));
            setSelectedClient(selected);
            selected.value != 0 ? renderProjectsByClientId(projectPage, projectSearch, selected.value) : dispatch(removeProjectAndTaskInBothList());
        } else if (control.name === "projectArray") {
            dispatch(updateProjectAndTaskInTimesheetList([
                { "item": "AccountProjectId", "value": selected.value, "index": index },
                { "item": "ProjectName", "value": selected.label, "index": index },
                { "item": "AccountProjectTaskId", "value": 0, "index": index },
                { "item": "TaskName", "value": "None", "index": index }]));
            selected.value != 0 ? renderProjectTasksByProjectId(selected.value, index) : dispatch(updateAccountProjectTaskArray({ "index": index, "taskArray": [{ value: 0, label: 'None' }] }));
        } else if (control.name === "taskArray") {
            dispatch(updateProjectAndTaskInTimesheetList([
                { "item": "AccountProjectTaskId", "value": selected.value, "index": index },
                { "item": "TaskName", "value": selected.label, "index": index }]));
            dispatch(updateAccountProjectTaskId(selected.value));
        }
    }

    // const handleInputTeam = (inputValue: string, control: any) => {
    //     if (control.name === "clientArray") {
    //         setSearch(inputValue);
    //     } else {
    //         setProjectSearch(inputValue);
    //     }
    // }

    const addRowInTimesheetBillingList = () => {
        dispatch(addItemTimesheetBillingList({
            "AccountClientId": 0,
            "EmployeeName": "",
            "ProjectName": "",
            "TaskName": "",
            "AccountProjectTaskId": 0,
            "AccountProjectId": 0,
            "AccountTimeExpenseBillingTimesheetId": "",
            "Description": "",
            "BillingRate": 0.0,
            "BillHours": 0.0,
            "TotalAmount": 0.0,
            "AccountTaxCodeId1": null,
            "AccountTaxCodeId2": null,
            "TaxCode2": 0.0,
            "TaxCode1": 0.0,
            "ActualHours": 0.0,
            "ActualBillingRate": 0.0,
            "PartyName": "",
            "AccountTimeExpenseBillingId": "",
            "AccountEmployeeTimeEntryId": null,
            "ExchangeRate": null,
            "AccountEmployeeId": null,
            "TaxName1": null,
            "TaxName2": null,
            "IsSelected": true,
            "IsEditable": false,
            "ProjectTaskArray": [{ index: 0, taskArray: [] }]
        }));
    }

    const addRowInExpenseBillingList = () => {
        dispatch(addItemExpenseBillingList({
            "ProjectName": null,
            "AccountProjectId": null,
            "AccountClientId": 0,
            "AccountTimeExpenseBillingExpenseId": "",
            "AccountTimeExpenseBillingId": "",
            "Description": "",
            "ActualExpenseAmount": 0,
            "BilledExpenseAmount": 0,
            "AccountExpenseId": null,
            "AccountExpenseName": null,
            "AccountExpenseTypeId": null,
            "ExpenseType": null,
            "ExchangeRate": 1,
            "AccountTaxCodeId1": null,
            "AccountTaxCodeId2": null,
            "TaxCode1": 0,
            "TaxCode2": 0,
            "AccountExpenseEntryId": "0",
            "TaxName1": null,
            "TaxName2": null,
            "IsSelected": true,
            "IsEditable": false
        }));
    }

    const removeRowInTimesheetBillingList = (index: number, id: string, accountProjectId: number) => {
        if (accountTimeExpenseBillingId === "" || accountProjectId === 0) {
            dispatch(removeItemInTimesheetBilling(index));
        } else {
            ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
                .then((result) => {
                    if (result) {
                        dispatch(deleteItemInTimesheetBilling({id, accountTimeExpenseBillingId}));
                        dispatch(deleteTimesheetBillingList(id)).then((response) => {
                            ShowToast('Success', response.payload[0].message, "success", "toast-top-right")
                        });
                    }
                })
                .catch((error) => {
                });
        }
    }

    const removeRowInExpenseBillingList = (index: number, id: string, accountProjectId: number) => {
        if (accountTimeExpenseBillingId === "" || accountProjectId === 0) {
            dispatch(removeItemInExpenseBilling(index));
        } else {
            ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
                .then((result) => {
                    if (result) {
                        dispatch(deleteItemInExpenseBilling({id, accountTimeExpenseBillingId}));
                        dispatch(deleteExpenseBillingList(id)).then((response) => {
                            ShowToast('Success', response.payload[0].message, "success", "toast-top-right")
                        });
                    }
                })
                .catch((error) => {
                });
        }
    }

    const generalObject = {
        "name": getValueFromResource("Invoice Information", dispatch, t),
        "width": "700px",
        "componentName": <GenerateInvoiceForm />
    }

    const onTimesheetBillingSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm({
            ...searchTerm,
            timesheetSearch: value
        });
        setCurrentPage({
            ...currentPage,
            timesheetCurrentPage: 1
        })
    }

    const onTimesheetBillingPageSize = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize({
            ...pageSize,
            timesheetPageSize: Number(value)
        });
        setCurrentPage({
            ...currentPage,
            timesheetCurrentPage: 1
        })
    }

    const onTimesheetBillingPageChange = (pageNumber: any) => {
        setCurrentPage({
            ...currentPage,
            timesheetCurrentPage: pageNumber
        });
    }


    const formatNumber = (value: number, culture: string) =>
    new Intl.NumberFormat(culture).format(value);

    const formattedTimesheetBillingList = timesheetBillingList.map(item => ({
        ...item,
        BillingRate:
            typeof item.BillingRate === 'number'
                ? FormatInvoiceDecimalNumber(cultureInfoName.toString() , item.BillingRate, decimalPlaces)
                : item.BillingRate,
        BillHours:
            typeof item.BillHours === 'number'
                ? FormatInvoiceDecimalNumber(cultureInfoName.toString() , item.BillHours, 2)
                : item.BillHours,
        TotalAmount:
            typeof item.TotalAmount === 'number'
                ? FormatInvoiceDecimalNumber(cultureInfoName.toString() , item.TotalAmount, decimalPlaces)
                : item.TotalAmount,        
    }));

    const filteredData: any = getFilteredList(Object.values(formattedTimesheetBillingList), searchTerm.timesheetSearch);
    const indexOfLastItem = currentPage.timesheetCurrentPage * pageSize.timesheetPageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize.timesheetPageSize;

    // this line will display all the records/rows on the page//
    const timesheetBillingCurrentItems = filteredData.slice(indexOfFirstItem);
    // const timesheetBillingCurrentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem); //this line for just display 10 records/rows on the page
    //const timesheetBillingCurrentItems = sortData(filteredData, timesheetClientSideSorting.sortOrder, timesheetClientSideSorting.sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const timesheetBillingTotalItems = Object.values(filteredData).length;

    const onExpenseBillingSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm({
            ...searchTerm,
            expenseSearch: value
        });
        setCurrentPage({
            ...currentPage,
            expenseCurrentPage: 1
        })
    }

    const onExpenseBillingPageSize = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize({
            ...pageSize,
            expensePageSize: Number(value)
        });
        setCurrentPage({
            ...currentPage,
            expenseCurrentPage: 1
        })
    }

    const onExpenseBillingPageChange = (pageNumber: any) => {
        setCurrentPage({
            ...currentPage,
            expenseCurrentPage: pageNumber
        });
    }

    const filteredDataExpense: any = getFilteredList(Object.values(expenseBillingList), searchTerm.expenseSearch);
    const indexOfLastItemExpense = currentPage.expenseCurrentPage * pageSize.expensePageSize;
    const indexOfFirstItemExpense = indexOfLastItemExpense - pageSize.expensePageSize;

    //this line will display all the rows of expense table in the expense table
    const expenseBillingCurrentItems = filteredDataExpense.slice(indexOfFirstItemExpense); 
    //  const expenseBillingCurrentItems = filteredDataExpense.slice(indexOfFirstItemExpense, indexOfLastItemExpense); //this line will display 10 rows in the expense table
    //const expenseBillingCurrentItems = sortData(filteredDataExpense, expenseClientSideSorting.sortOrder, expenseClientSideSorting.sortColumn).slice(indexOfFirstItemExpense, indexOfLastItemExpense);
    const expenseBillingTotalItems = Object.values(filteredDataExpense).length;
    const colourStyles: StylesConfig = {
        control: (styles) => ({ ...styles, backgroundColor: 'white', width: 200, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0' })
    }

    const updateInvoiceForm = async () => {
        let expenseRowCount: number[] = [];
        let timeRowCount: number[] = [];
        let expenseMessage: string = "";
        let timesheetMessage: string = "";
        expenseBillingList.map((item: any, index: number) => {
            if (item.ProjectName != null || item.AccountExpenseName != null || item.ExpenseType != null || item.Description != "") {
            } else {
                expenseRowCount.push(index);
                expenseMessage = "Please select either the project name, expense name, expense type, or description in the Expense Billing list for rows " + expenseRowCount.toString();
            }
        })
        timesheetBillingList.map((item: any, index: number) => {
            if (item.ProjectName != "" || item.TaskName != "" || item.Description != "") {
            } else {
                timeRowCount.push(index);
                timesheetMessage = "Please select either the project name, task name, or description in the Timesheet Billing list for rows " + timeRowCount.toString();
            }
        })
        if (timesheetMessage != "" || expenseMessage != "") {
            let finalArray: string[] = [];
            timesheetMessage != "" && finalArray.push(timesheetMessage);
            expenseMessage != "" && finalArray.push(expenseMessage);
            setErrorValues({
                ...setError,
                isError: true,
                errorMessage: finalArray

            });
        } else {
            setErrorValues({
                ...setError,
                isError: false,
                errorMessage: []

            });
            
            dispatch(updateAccountInvoice()).then((result) => {
                if (result.payload.StatusCode === "200") {
                    ShowToast('Success', "Invoice Updated Successfully", "success", "toast-top-right");
                } else {
                    ShowToast('error', "Invoice Updated Failed", "error", "toast-top-right");
                }
                navigate('/accounttimeexpensebilling');
            }).catch((error) => {
            });
        }
    }

    const recalculateInvoiceTotal = async () => {
        const response: any = await fetchAPI(`api/Invoice/RecalculateInvoice/${accountTimeExpenseBillingId}`, "GET", "", true);
        const json = await response.json();
        if (json.length > 0) {
            dispatch(reCalculateInvoiceTotal(json[0]));
            ShowToast('Success', "Your invoice amount is re-calculated", "success", "toast-top-right");
        } else {
            ShowToast('Error', "Your invoice amount cannot be recalculated.", "error", "toast-top-right");
        }
    }

    const triggerInvoicePrintView = () => {
        modelRef.current.click();
        dispatch(updateTimeExpenseBillingIdForPrint(accountTimeExpenseBillingId));
    }

    const onHandleTimesheetClientSideSorting = (sortOrder: string, sortColumn: string) => {
        setTimesheetClientSideSorting({
            ...timesheetClientSideSorting,
            sortOrder: sortOrder,
            sortColumn: sortColumn
        });
        setPageSize({
            ...pageSize,
            timesheetPageSize: pageSize.timesheetPageSize
        });
        setCurrentPage({
            ...currentPage,
            timesheetCurrentPage: 1
        })
    }

    const onHandleExpenseClientSideSorting = (sortOrder: string, sortColumn: string) => {
        setExpenseClientSideSorting({
            ...expenseClientSideSorting,
            sortOrder: sortOrder,
            sortColumn: sortColumn
        });
        setPageSize({
            ...pageSize,
            expensePageSize: pageSize.expensePageSize
        });
        setCurrentPage({
            ...currentPage,
            expenseCurrentPage: 1
        })
    }

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }
    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card-billing-parent" >
                <div className="card-header card-drop-dr sticky-top bg-white">
                    <div className="d-flex align-items-center">
                        <span className="fs-7 fw-bold pe-3 d-none d-md-block" style={{ color: '#181c32' }}>
                            {/* {t('Client')} */}
                            {getValueFromResource('Client',dispatch, t)}
                            </span>
                        <Select
                            value={accountTimeExpenseBillingId == "" ? selectedClient : (dataClient.filter(x => x.value === getMasterRecord.AccountClientId).length > 0 ? dataClient.filter(x => x.value === getMasterRecord.AccountClientId) : { value: getMasterRecord.AccountClientId, label: getMasterRecord.ClientName })}
                            className='fs-7 fw-normal'
                            classNamePrefix="select"
                            name="clientArray"
                            onChange={(e, name) => handleChangeOption(e, name, 0)}
                            options={dataClient}
                            styles={colourStyles}
                            // menuPortalTarget={document.body}
                            menuPosition='fixed'
                            maxMenuHeight={maxMenuHeight}
                            onInputChange={(e, name) => setSearch(e)}
                            // components={{ MenuList: customMenuList }}
                            // components={{ MenuList: (props) => customMenuList({ ...props, innerRef: menuRef }) }}
                            isDisabled={accountTimeExpenseBillingId == "" ? false : true}
                        // isLoading={loading}
                        />
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <span className="fs-7 fw-bold pe-3 d-none d-md-block" style={{ color: '#181c32' }}>{t(Number(getMasterRecord.ShowDiscountCalculationBy) === 0 ? getValueFromResource('Discount Percentage:', dispatch, t) : getValueFromResource('Discount Amount', dispatch, t))}</span>
                        <div className="wrapper">
                            {/* <input
                                type="number"
                                className="form-control inputFieldInvoice"
                                value={discountPercentage}
                                onChange={(e) => dispatch(updateDiscountValues(e.target.value))}
                            /> */}                            
                            <input
                                type="text"
                                className="form-control inputFieldInvoice"
                                value={discountInput}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const lblSeparator = getDecimalSeparator(cultureInfoName.toString());
                                    const regex = new RegExp(`^[0-9${lblSeparator}]*$`);
                                    if (!regex.test(value)) return;
                                    setDiscountInput(value);
                                }}
                                onBlur={(e) => {
                                    let value = e.target.value; 
                                    const numberValue = parseLocalizedNumber(value) || 0;
                                    const formatted = FormatInvoiceDecimalNumber(cultureInfoName.toString(),numberValue,2);
                                    setDiscountInput(formatted);
                                    dispatch(updateDiscountValues(numberValue));
                                }}
                            />
                            {Number(getMasterRecord.ShowDiscountCalculationBy) === 0 && <i className="insideField-Icons bi bi-percent text-gray fs-5" style={{ top: 3 }}></i>}
                        </div>
                        {accountTimeExpenseBillingId != "" && <><div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <a
                                ref={modelRef}
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#invoicePrintModal"
                                onClick={triggerInvoicePrintView}
                                className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                data-tooltip-id="tooltip-Description"
                                data-tooltip-content=
                                // {"Print"}
                                {getValueFromResource('Print',dispatch, t)}
                                data-tooltip-place="bottom">
                                <i className="bi bi-printer fs-3 iconColor"></i>
                            </a>
                        </>}
                    </div>
                    <div className='h-35px w-1px mx-1'></div>
                    <div className="card-toolbar align-items-center">
                        {accountTimeExpenseBillingId != "" && <>
                            <button
                                type="button"
                                className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                onClick={() => {
                                    recalculateInvoiceTotal();
                                }}
                            >
                                {/* {t("Re-Calculate Amount")} */}
                                {getValueFromResource('Re-Calculate Amount',dispatch, t)}
                            </button>
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        </>}
                        <button
                            id={"kt_OffCanvas"}
                            type="button"
                            className="btn btn-primary btn-bs-btn-font-weight btn-sm">
                            {/* {t(accountTimeExpenseBillingId === "" ? t('Generate Invoice') : 'Re-Generate Invoice')} */}
                            {getValueFromResource(
                                accountTimeExpenseBillingId === "" ? 'Generate Invoice' : 'Re-Generate Invoice',
                                dispatch,
                                t
                            )}
                        </button>
                        {accountTimeExpenseBillingId === "" && getMasterRecord.AccountClientId != 0 && (timesheetBillingList.length > 0 || expenseBillingList.length > 0) && <>
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <button
                                type="button"
                                className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                onClick={() => {
                                    dispatch(updateMasterTimeExpenseBillingValuesByClient([{ "item": "IsBilled", "value": false }]))
                                    updateInvoiceForm()
                                }}
                            > 
                            {/* {t('Update')} */}
                            {getValueFromResource('Update',dispatch, t)}
                            </button>
                        </>
                        }
                        {accountTimeExpenseBillingId != "" && <><div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <div className="btn-group">
                                <button
                                    type="button"
                                    className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                    onClick={() => {
                                        dispatch(updateMasterTimeExpenseBillingValuesByClient([{ "item": "IsBilled", "value": false }]))
                                        updateInvoiceForm()
                                    }}> 
                                    {/* {t('Update Invoice')} */}
                                    {getValueFromResource('Update Invoice',dispatch, t)}
                                </button>
                                <button type="button" className="btn btn-primary btn-bs-btn-font-weight btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="fa fa-angle-down"></i>
                                </button>
                                <ul className=" dropdown-menu menu-rounded px-1 py-1 fs-2" role="menu">
                                    <div className='menu-hover-bg-sec'>
                                        <Dropdown.Item
                                            className="menu-item me-lg-0"
                                            onClick={() => {
                                                dispatch(updateMasterTimeExpenseBillingValuesByClient([{ "item": "IsBilled", "value": true }]))
                                                updateInvoiceForm()
                                            }}
                                        >
                                            <span className="menu-icon custom-menu mb-2">
                                                <i className="bi bi-file-earmark-text fs-6 iconColor">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                            <span className="menu-title custom-menu-fontsize" style={{ paddingRight: 6 }}>
                                                {/* {`${t('Update Invoice As Billed')}`} */}
                                                {getValueFromResource('Update Invoice As Billed',dispatch, t)}
                                                </span>
                                        </Dropdown.Item>
                                    </div>
                                </ul>
                            </div>
                        </>}
                    </div>
                </div>
                <AccountInvoiceFormNavBar />
                {setError.isError && <div id="validationerror" className="alert alert-danger">
                    <strong>Error!</strong>
                    <ul>
                        {setError.errorMessage.map((item: any, index: number) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </div>}
                
                    <div className="card card-custom admin-card-billing-child">
                        <div className="card-header card-drop-top sticky-top bg-white">
                            <h3 className="card-title fw-bold headerTitle">
                                {/* {t('Timesheet Billing List')} */}
                                {getValueFromResource('Timesheet Billing List',dispatch, t)}
                                </h3>
                            <div className="card-toolbar align-items-center">
                                {/* <div className="position-relative">
                                    <input
                                        type="text"
                                        value={searchTerm.timesheetSearch}
                                        onChange={onTimesheetBillingSearch}
                                        placeholder=
                                        // {t('Search')}
                                        {getValueFromResource('Search',dispatch, t)}
                                        className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                        data-kt-user-table-filter="search"
                                    />
                                    <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </div> */}
                                {/* <div className='h-35px w-1px mx-1'></div> */}
                                {/* <div className="d-flex align-items-center"> */}
                                    {/* <Select
                                        styles={paginationStyles}
                                        maxMenuHeight={maxMenuHeight}
                                        options={getPageSizeArray()}
                                        value={getPageSizeArray().find((option: any) => option.value == pageSize.timesheetPageSize)}
                                        onChange={onTimesheetBillingPageSize}
                                        menuPortalTarget={document.body}
                                        menuPosition='fixed'
                                        className='fs-7 fw-normal'
                                    /> */}

                                     {/* <PageSizeSelect onChange={onTimesheetBillingPageSize} /> */}
 
                                {/* </div> */}
                            {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div> */}
                            {/* {(timesheetBillingList.length > 0) && (
                                <>
                                    <CustomPagination
                                        currentPage={currentPage.timesheetCurrentPage}
                                        onPageChange={onTimesheetBillingPageChange}
                                        pageSize={pageSize.timesheetPageSize}
                                        totalItems={timesheetBillingTotalItems}
                                        start={(currentPage.timesheetCurrentPage - 1) * pageSize.timesheetPageSize}
                                        t={t}
                                    />
                                    <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                </>
                            )} */}
                                <button
                                    type="button"
                                    className="btn btn-primary btn-bs-btn-font-weight btn-sm fs-8"
                                    onClick={() => { addRowInTimesheetBillingList() }}
                                    style={{ padding: '8px 8px 8px 8px' }}
                                >
                                     {/* {t('Add Row')} */}
                                     {getValueFromResource('Add Row',dispatch, t)}
                                </button>
                            </div>
                        </div>
                        <div className='card-body py-3'>
                            <div className='table-responsive'>
                                <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                                    <thead>
                                        <tr className='thHeading align-middle'>
                                            <th style={{ width: '10%' }}
                                            //className='min-w-150px'
                                            // onMouseEnter={() => handleMouseEnter(0)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Project Name")} */}
                                                {getValueFromResource('Project Name',dispatch, t)}
                                                {timesheetClientSideSorting.sortColumn === 'ProjectName' ?
                                                    timesheetClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "ProjectName") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "ProjectName") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 0 && 
                                                    <><span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "ProjectName") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "ProjectName") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{ width: '10%' }}
                                            //className='min-w-150px'
                                            // onMouseEnter={() => handleMouseEnter(1)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Task Name")} */}
                                                {getValueFromResource('Task Name',dispatch, t)}
                                                {timesheetClientSideSorting.sortColumn === 'TaskName' ?
                                                    timesheetClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "TaskName") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "TaskName") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 1 && 
                                                    <><span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "TaskName") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "TaskName") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{ width: '10%' }}
                                            // className='min-w-150px'
                                            // onMouseEnter={() => handleMouseEnter(2)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Description")} */}
                                                {getValueFromResource('Description',dispatch, t)}
                                                {timesheetClientSideSorting.sortColumn === 'Description' ?
                                                    timesheetClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "Description") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "Description") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 2 && 
                                                    <><span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "Description") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "Description") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{ width: '10%' }}
                                            // className='min-w-100px'
                                            // onMouseEnter={() => handleMouseEnter(3)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Actual Rate")} */}
                                                {getValueFromResource('Actual Rate',dispatch, t)}
                                                {timesheetClientSideSorting.sortColumn === 'ActualBillingRate' ?
                                                    timesheetClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "ActualBillingRate") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "ActualBillingRate") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 3 && 
                                                    <><span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "ActualBillingRate") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "ActualBillingRate") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{ width: '10%' }}
                                            // className='min-w-100px'
                                            // onMouseEnter={() => handleMouseEnter(4)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Bill Rate")} */}
                                                {getValueFromResource('Bill Rate',dispatch, t)}
                                                {timesheetClientSideSorting.sortColumn === 'BillingRate' ?
                                                    timesheetClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "BillingRate") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "BillingRate") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 4 && 
                                                    <><span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "BillingRate") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "BillingRate") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{width:'10%'}}
                                            // className='min-w-100px'
                                            // onMouseEnter={() => handleMouseEnter(5)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Actual Hours")} */}
                                                {getValueFromResource('Actual Hours',dispatch, t)}
                                                {timesheetClientSideSorting.sortColumn === 'ActualHours' ?
                                                    timesheetClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "ActualHours") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "ActualHours") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 5 && 
                                                    <><span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "ActualHours") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "ActualHours") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{width:'10%'}}
                                            // className='min-w-100px'
                                            // onMouseEnter={() => handleMouseEnter(6)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Bill Hours")} */}
                                                {getValueFromResource('Bill Hours',dispatch, t)}
                                                {timesheetClientSideSorting.sortColumn === 'BillHours' ?
                                                    timesheetClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "BillHours") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "BillHours") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 6 && 
                                                    <><span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "BillHours") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "BillHours") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{width:'10%'}}
                                            // className='min-w-100px'
                                            // onMouseEnter={() => handleMouseEnter(7)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Tax 1")} */}
                                                {getValueFromResource('Tax 1',dispatch, t)}
                                                {timesheetClientSideSorting.sortColumn === 'TaxName1' ?
                                                    timesheetClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "TaxName1") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "TaxName1") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 7 && 
                                                    <><span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "TaxName1") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "TaxName1") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{width:'10%'}}
                                            // className='min-w-100px'
                                            // onMouseEnter={() => handleMouseEnter(8)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Tax 2")} */}
                                                {getValueFromResource('Tax 2',dispatch, t)}
                                                {timesheetClientSideSorting.sortColumn === 'TaxName2' ?
                                                    timesheetClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "TaxName2") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "TaxName2") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 8 && 
                                                    <><span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "TaxName2") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "TaxName2") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{width:'10%'}}
                                            // className='min-w-100px'
                                            // onMouseEnter={() => handleMouseEnter(9)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Total")} */}
                                                {getValueFromResource('Total',dispatch, t)}
                                                {timesheetClientSideSorting.sortColumn === 'TotalAmount' ?
                                                    timesheetClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "TotalAmount") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "TotalAmount") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 9 && 
                                                    <><span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("asc", "TotalAmount") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleTimesheetClientSideSorting("desc", "TotalAmount") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th className='min-w-100px'>
                                                {/* {t("Action")} */}
                                                {getValueFromResource('Action',dispatch, t)}
                                                </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {timesheetBillingCurrentItems.length > 0 && timesheetBillingCurrentItems.map((item: any, index: number) => {
                                            return (
                                                <tr style={{ height: 50 }}>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <Select
                                                            value={projectResponse.filter((x: any) => x.value === item.AccountProjectId)}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            options={projectResponse}
                                                            styles={localColourStyles}
                                                            isDisabled={getMasterRecord.AccountClientId === 0 ? true : false}
                                                            maxMenuHeight={maxMenuHeight}
                                                            menuPortalTarget={document.body}
                                                            menuPosition='fixed'
                                                            name="projectArray"
                                                            onChange={(e, name) => handleChangeOption(e, name, index)}
                                                        /> : <a className='text-dark fw-bold d-block'>
                                                            {item.ProjectName}
                                                        </a>}
                                                    </td>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <Select
                                                            //value={item.ProjectTaskArray.filter((x: any) => x.value === item.AccountProjectTaskId)}
                                                            value={(item.ProjectTaskArray ?? []).filter((x: any) => x.value === item.AccountProjectTaskId)}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            options={item.ProjectTaskArray}
                                                            styles={localColourStyles}
                                                            isDisabled={item.AccountProjectId === 0 ? true : false}
                                                            maxMenuHeight={maxMenuHeight}
                                                            menuPortalTarget={document.body}
                                                            menuPosition='fixed'
                                                            name="taskArray"
                                                            onChange={(e, name) => handleChangeOption(e, name, index)}
                                                        /> : <a className='text-dark fw-bold d-block'>
                                                            {item.TaskName}
                                                        </a>}
                                                    </td>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <textarea
                                                            value={item.Description}
                                                            name="projectDescription"
                                                            className="form-control fs-7 fw-normal"
                                                            rows={1}
                                                            onChange={(e) => dispatch(updateTimesheetBillingValues({
                                                                "index": index,
                                                                "item": "Description",
                                                                "value": e.target.value,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                            }))}
                                                            style={{ resize: 'none' }}
                                                        ></textarea> : <a className='text-gray-800 d-block'>
                                                            {item.Description}
                                                        </a>}
                                                    </td>
                                                    <td>
                                                        <a className='text-gray-800 d-block'>
                                                            {/* {item.ActualBillingRate.toFixed(2)} */}
                                                            {FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.ActualBillingRate, decimalPlaces)}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <input
                                                            type="text"
                                                            className="form-control inputFieldAlignment"
                                                            name="BillingRate"
                                                            value={item.BillingRate}
                                                            /*     onChange={(e) => dispatch(updateTimesheetBillingValues({
                                                                    "index": index,
                                                                    "item": "BillingRate",
                                                                    "value": e.target.value
                                                                    }))} */
                                                            onBlur={(e) => {
                                                                let val = e.target.value.trim();
                                                                                                                                
                                                                if (!val || val === '') {
                                                                    const formatted = formatNumberCustomoriginal(
                                                                        cultureInfoName.toString(),
                                                                        '0',
                                                                        decimalPlaces
                                                                    );
                                                                    dispatch(updateTimesheetBillingValues({
                                                                        "index": index,
                                                                        "item": "BillingRate",
                                                                        "value": formatted,
                                                                        "cultureInfoName": cultureInfoName.toString()
                                                                    }))
                                                                } else {
                                                                    const formatted = formatNumberCustomoriginal(
                                                                        cultureInfoName.toString(),
                                                                        val,
                                                                        decimalPlaces
                                                                    );
                                                                    dispatch(updateTimesheetBillingValues({
                                                                        "index": index,
                                                                        "item": "BillingRate",
                                                                        "value": formatted,
                                                                        "cultureInfoName": cultureInfoName.toString()
                                                                    }))
                                                                }
                                                            }}
                                                            onChange={(e: any) => {
                                                                const val = e.target.value;
                                                                if (!validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                                                    return;
                                                                }
                                                                dispatch(updateTimesheetBillingValues({
                                                                    "index": index,
                                                                    "item": "BillingRate",
                                                                    "value": e.target.value,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                                }))
                                                            }}
                                                            style={{ width: 110 }}
                                                        /> : <a className='text-gray-800 d-block'>
                                                            {/* {Number(item.BillingRate).toFixed(2)} */}
                                                            {/* {FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.BillingRate, decimalPlaces)} */}
                                                            {item.BillingRate}
                                                        </a>}
                                                    </td>
                                                    <td>
                                                        <a className='text-gray-800 d-block'>
                                                             {FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.ActualHours, 2)}
                                                           
                                                        </a>
                                                    </td>
                                                    {/* <td>
                                                        {item.IsSelected || item.IsEditable ? <input
                                                            type="text"
                                                            className="form-control inputFieldAlignment"
                                                            name="BillHours"
                                                            value={item.BillHours}
                                                            onChange={(e) => dispatch(updateTimesheetBillingValues({
                                                                "index": index,
                                                                "item": "BillHours",
                                                                "value": e.target.value,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                            }))}
                                                            style={{ width: 110 }}
                                                        />
                                                            : <a className='text-gray-800 d-block'>
                                                                {Number(item.BillHours).toFixed(2)}
                                                            </a>}
                                                    </td> */}
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? (
                                                            <input
                                                                type="text"
                                                                className="form-control inputFieldAlignment"
                                                                name="BillHours"
                                                                value={item.BillHours}
                                                                onBlur={(e) => {
                                                                    let val = e.target.value.trim();

                                                                    const formatted = formatNumberCustomoriginal(
                                                                        cultureInfoName.toString(),
                                                                        !val ? '0' : val,
                                                                        2
                                                                    );

                                                                    dispatch(updateTimesheetBillingValues({
                                                                        index: index,
                                                                        item: "BillHours",
                                                                        value: formatted,
                                                                        cultureInfoName: cultureInfoName.toString()
                                                                    }));
                                                                }}
                                                                onChange={(e: any) => {
                                                                    const val = e.target.value;

                                                                    if (!validateCultureNumber(
                                                                        val,
                                                                        cultureInfoName.toString(),
                                                                        2
                                                                    )) {
                                                                        return;
                                                                    }

                                                                    dispatch(updateTimesheetBillingValues({
                                                                        index: index,
                                                                        item: "BillHours",
                                                                        value: val,
                                                                        cultureInfoName: cultureInfoName.toString()
                                                                    }));
                                                                }}
                                                                style={{ width: 110 }}
                                                            />
                                                        ) : (
                                                            <a className="text-gray-800 d-block">
                                                                {/* {FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.BillHours,2)} */}
                                                                 {item.BillHours}
                                                            </a>
                                                        )}
                                                    </td>

                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <Select
                                                            value={accountTaxCodeList.filter((x: any) => x.value === (item.AccountTaxCodeId1 === null ? 0 : item.AccountTaxCodeId1))}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            options={accountTaxCodeList}
                                                            styles={taxCodeColourStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                            menuPortalTarget={document.body}
                                                            menuPosition='fixed'
                                                            onChange={(e) => {
                                                                dispatch(updateTimesheetBillingValues({
                                                                    "index": index,
                                                                    "item": "AccountTaxCodeId1",
                                                                    "value": e.value,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                                }))
                                                                dispatch(updateProjectAndTaskInTimesheetList([{ "item": "TaxName1", "value": e.label, "index": index }]))
                                                            }}
                                                        /> : <a className='text-gray-800 d-block'>
                                                            {item.TaxName1 === null ? 'None' : item.TaxName1}
                                                        </a>
                                                        }
                                                    </td>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <Select
                                                            value={accountTaxCodeList.filter((x: any) => x.value === (item.AccountTaxCodeId2 === null ? 0 : item.AccountTaxCodeId2))}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            options={accountTaxCodeList}
                                                            styles={taxCodeColourStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                            menuPortalTarget={document.body}
                                                            menuPosition='fixed'
                                                            onChange={(e) => {
                                                                dispatch(updateTimesheetBillingValues({
                                                                    "index": index,
                                                                    "item": "AccountTaxCodeId2",
                                                                    "value": e.value,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                                }))
                                                                dispatch(updateProjectAndTaskInTimesheetList([{ "item": "TaxName2", "value": e.label, "index": index }]))
                                                            }}
                                                        /> : <a className='text-gray-800 d-block'>
                                                            {item.TaxName2 === null ? 'None' : item.TaxName2}
                                                        </a>}
                                                    </td>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? 
                                                        <input
                                                            type="text"
                                                            className="form-control inputFieldAlignment"
                                                            name="TotalAmount"
                                                            value={item.TotalAmount}
                                                            readOnly={true}
                                                            style={{ width: 110 }}
                                                            
                                                        />
                                                            : <a className='text-gray-800 d-block'>
                                                                {/* {item.TotalAmount.toFixed(2)} */}
                                                                {item.TotalAmount}
                                                            </a>
                                                        }
                                                    </td>
                                                    <td>
                                                        {!item.IsSelected && <>
                                                            {!item.IsEditable && <span className="menu-icon custom-menu mb-2 cursor"
                                                                onClick={() => { dispatch(isEditableTimesheetList(item.AccountTimeExpenseBillingTimesheetId || item.AccountEmployeeTimeEntryId)) }}
                                                                data-tooltip-id="tooltip-Description"
                                                                data-tooltip-content=
                                                                // {t("Editable")}
                                                                {getValueFromResource('Editable',dispatch, t)}
                                                                data-tooltip-place="top"
                                                            >
                                                                <i className="bi bi-pencil-square fs-6 iconColor">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>}
                                                            {item.IsEditable && <span className="menu-icon custom-menu mb-2 cursor"
                                                                onClick={() => { dispatch(isCancelTimesheetList(item.AccountTimeExpenseBillingTimesheetId || item.AccountEmployeeTimeEntryId)) }}
                                                                data-tooltip-id="tooltip-Description"
                                                                data-tooltip-content=
                                                                // {t("Cancel")}
                                                                {getValueFromResource('Cancel',dispatch, t)}
                                                                data-tooltip-place="top"
                                                            >
                                                                <i className="bi bi-x-lg fs-6 iconColor">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>}
                                                        </>}
                                                        <span className="menu-icon custom-menu mb-2 cursor"
                                                            onClick={() => removeRowInTimesheetBillingList(index, item.AccountTimeExpenseBillingTimesheetId, item.AccountProjectId)}
                                                            data-tooltip-id="tooltip-Description"
                                                            data-tooltip-content=
                                                            // {t("Delete")}
                                                            {getValueFromResource('Delete',dispatch, t)}
                                                            data-tooltip-place="top">
                                                            <i className="bi bi-trash fs-6 iconColor allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                                {timesheetBillingCurrentItems.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="card card-custom admin-card-billing-child " >
                        <div className="card-header card-drop  sticky-top bg-white">
                            <h3 className="card-title fw-bold headerTitle">
                                {/* {t('Expense Billing List')} */}
                                {getValueFromResource('Expense Billing List',dispatch, t)}
                                </h3>
                            <div className="card-toolbar  align-items-center">
                                {/* <div className="position-relative">
                                    <input
                                        type="text"
                                        value={searchTerm.expenseSearch}
                                        onChange={onExpenseBillingSearch}
                                        placeholder=
                                        // {t('Search')}
                                        {getValueFromResource('Search',dispatch, t)}
                                        className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                        data-kt-user-table-filter="search"
                                    />
                                    <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </div>
                                <div className='h-35px w-1px mx-1'></div>
                                <div className="d-flex align-items-center"> */}
                                    {/* <Select
                                        styles={paginationStyles}
                                        maxMenuHeight={maxMenuHeight}
                                        options={getPageSizeArray()}
                                        value={getPageSizeArray().find((option: any) => option.value == pageSize.expensePageSize)}
                                        onChange={onExpenseBillingPageSize}
                                        className='fs-7 fw-normal'
                                    /> */}
                                           {/* <PageSizeSelect onChange={onExpenseBillingPageSize} /> */}


                                {/* </div> */}
                            {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div> */}
                            {/* {(expenseBillingList.length > 0) && (
                                <>
                                    <CustomPagination
                                        currentPage={currentPage.expenseCurrentPage}
                                        onPageChange={onExpenseBillingPageChange}
                                        pageSize={pageSize.expensePageSize}
                                        totalItems={expenseBillingTotalItems}
                                        start={(currentPage.expenseCurrentPage - 1) * pageSize.expensePageSize}
                                        t={t}
                                    />
                                    <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                </>
                            )} */}
                                <button
                                    type="button"
                                    className="btn btn-primary btn-bs-btn-font-weight btn-sm fs-8"
                                    onClick={() => { addRowInExpenseBillingList() }}
                                    style={{ padding: '8px 8px 8px 8px' }}
                                >
                                     {/* {t('Add Row')} */}
                                     {getValueFromResource('Add Row',dispatch, t)}
                                </button>
                            </div>
                        </div>
                        <div className='card-body py-3'>
                            <div className='table-responsive'>
                                <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                                    <thead>
                                        <tr className='thHeading align-middle'>
                                            <th style={{ width: '15%' }}
                                            //className='min-w-150px'
                                            // onMouseEnter={() => handleMouseEnter(10)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Project Name")} */}
                                                {getValueFromResource('Project Name',dispatch, t)}
                                                {expenseClientSideSorting.sortColumn === 'ProjectName' ?
                                                    expenseClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "ProjectName") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "ProjectName") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 10 && 
                                                    <><span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "ProjectName") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "ProjectName") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{ width: '15%' }}
                                            //className='min-w-150px'
                                            // onMouseEnter={() => handleMouseEnter(11)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Expense Name")} */}
                                                {getValueFromResource('Expense Name',dispatch, t)}
                                                {expenseClientSideSorting.sortColumn === 'AccountExpenseName' ?
                                                    expenseClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "AccountExpenseName") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "AccountExpenseName") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 11 && 
                                                    <><span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "AccountExpenseName") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "AccountExpenseName") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{ width: '15%' }}
                                            //className='min-w-150px'
                                            // onMouseEnter={() => handleMouseEnter(12)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Expense Type")} */}
                                                {getValueFromResource('Expense Type',dispatch, t)}
                                                {expenseClientSideSorting.sortColumn === 'ExpenseType' ?
                                                    expenseClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "ExpenseType") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "ExpenseType") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 12 && 
                                                    <><span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "ExpenseType") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "ExpenseType") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{ width: '15%' }}
                                                className='min-w-100px'
                                            // onMouseEnter={() => handleMouseEnter(13)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Description")} */}
                                                {getValueFromResource('Description',dispatch, t)}
                                                {expenseClientSideSorting.sortColumn === 'Description' ?
                                                    expenseClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "Description") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "Description") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 13 && 
                                                    <><span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "Description") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "Description") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{ width: '10%' }}
                                            //className='min-w-100px'
                                            // onMouseEnter={() => handleMouseEnter(14)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Actual Amount")} */}
                                                {getValueFromResource('Actual Amount',dispatch, t)}
                                                {expenseClientSideSorting.sortColumn === 'ActualExpenseAmount' ?
                                                    expenseClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "ActualExpenseAmount") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "ActualExpenseAmount") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 14 && 
                                                    <><span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "ActualExpenseAmount") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "ActualExpenseAmount") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{ width: '10%' }}
                                            //className='min-w-100px'
                                            // onMouseEnter={() => handleMouseEnter(15)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Tax 1")} */}
                                                {getValueFromResource('Tax 1',dispatch, t)}
                                                {expenseClientSideSorting.sortColumn === 'TaxName1' ?
                                                    expenseClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "TaxName1") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "TaxName1") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 15 && 
                                                    <><span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "TaxName1") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "TaxName1") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{ width: '10%' }}
                                            //className='min-w-100px'
                                            // onMouseEnter={() => handleMouseEnter(16)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Tax 2")} */}
                                                {getValueFromResource('Tax 2',dispatch, t)}
                                                {expenseClientSideSorting.sortColumn === 'TaxName2' ?
                                                    expenseClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "TaxName2") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "TaxName2") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 16 && 
                                                    <><span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "TaxName2") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "TaxName2") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th style={{ width: '10%' }}
                                            //className='min-w-120px'
                                            // onMouseEnter={() => handleMouseEnter(17)}
                                            // onMouseLeave={handleMouseLeave}
                                            >
                                                {/* {t("Billed Amount")} */}
                                                {getValueFromResource('Billed Amount',dispatch, t)}
                                                {expenseClientSideSorting.sortColumn === 'BilledExpenseAmount' ?
                                                    expenseClientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "BilledExpenseAmount") }}>
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "BilledExpenseAmount") }}>
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                    :
                                                    // hoveredColumn === 17 && 
                                                    <><span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("asc", "BilledExpenseAmount") }}>
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                        <span className="cursor" onClick={() => { onHandleExpenseClientSideSorting("desc", "BilledExpenseAmount") }}>
                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </>}
                                            </th>
                                            <th className='min-w-100px'>
                                                {/* {t("Action")} */}
                                                {getValueFromResource('Action',dispatch, t)}
                                                </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {expenseBillingCurrentItems.length > 0 && expenseBillingCurrentItems.map((item: any, index: number) => {
                                            return (
                                                <tr style={{ height: 50 }}>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <Select
                                                            value={projectResponse.filter((x: any) => x.value === (item.AccountProjectId === null ? 0 : item.AccountProjectId))}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            options={projectResponse}
                                                            styles={localColourStyles}
                                                            isDisabled={getMasterRecord.AccountClientId === 0 ? true : false}
                                                            maxMenuHeight={maxMenuHeight}
                                                            menuPortalTarget={document.body}
                                                            menuPosition='fixed'
                                                            onChange={(e) => {
                                                                dispatch(updateExpenseBillingValues({
                                                                    "index": index,
                                                                    "item": "AccountProjectId",
                                                                    "value": e.value,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                                }))
                                                                dispatch(updateProjectAndTaskInExpenseList([{ "item": "ProjectName", "value": e.label, "index": index }]))
                                                            }}
                                                        /> : <a className='text-dark fw-bold d-block'>
                                                            {item.ProjectName === null ? 'None' : item.ProjectName}
                                                        </a>}
                                                    </td>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <Select
                                                            value={accountExpenseNameList.filter((x: any) => x.value === (item.AccountExpenseId === null ? 0 : item.AccountExpenseId))}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            options={accountExpenseNameList}
                                                            styles={localColourStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                            menuPortalTarget={document.body}
                                                            menuPosition='fixed'
                                                            onChange={(e) => {
                                                                dispatch(updateExpenseBillingValues({
                                                                    "index": index,
                                                                    "item": "AccountExpenseId",
                                                                    "value": e.value,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                                }))
                                                                dispatch(updateProjectAndTaskInExpenseList([{ "item": "AccountExpenseName", "value": e.label, "index": index }]))
                                                            }}
                                                        /> : <a className='text-dark fw-bold d-block'>
                                                            {item.AccountExpenseName == null ? 'None' : item.AccountExpenseName}
                                                        </a>}
                                                    </td>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <Select
                                                            value={accountExpenseTypeList.filter((x: any) => x.value === (item.AccountExpenseTypeId === null ? 0 : item.AccountExpenseTypeId))}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            options={accountExpenseTypeList}
                                                            styles={localColourStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                            menuPortalTarget={document.body}
                                                            menuPosition='fixed'
                                                            onChange={(e) => {
                                                                dispatch(updateExpenseBillingValues({
                                                                    "index": index,
                                                                    "item": "AccountExpenseTypeId",
                                                                    "value": e.value,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                                }))
                                                                dispatch(updateProjectAndTaskInExpenseList([{ "item": "ExpenseType", "value": e.label, "index": index }]))
                                                            }}
                                                        /> : <a className='text-gray-800 d-block'>
                                                            {item.ExpenseType == null ? 'None' : item.ExpenseType}
                                                        </a>}
                                                    </td>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <textarea
                                                            value={item.Description}
                                                            name="projectDescription"
                                                            className="form-control fs-7 fw-normal"
                                                            rows={1}
                                                            onChange={(e) => dispatch(updateExpenseBillingValues({
                                                                "index": index,
                                                                "item": "Description",
                                                                "value": e.target.value,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                            }))}
                                                            style={{ resize: 'none' }}
                                                        ></textarea> : <a className='text-gray-800 d-block'>
                                                            {item.Description}
                                                        </a>}
                                                    </td>
                                                    <td>
                                                        <a className='text-gray-800 d-block'>
                                                            {/* {item.ActualExpenseAmount.toFixed(2)} */}
                                                            {FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.ActualExpenseAmount, decimalPlaces)}
                                                            
                                                        </a>
                                                    </td>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <Select
                                                            value={accountTaxCodeList.filter((x: any) => x.value === (item.AccountTaxCodeId1 === null ? 0 : item.AccountTaxCodeId1))}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            options={accountTaxCodeList}
                                                            styles={taxCodeColourStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                            menuPortalTarget={document.body}
                                                            menuPosition='fixed'
                                                            onChange={(e) => {
                                                                dispatch(updateExpenseBillingValues({
                                                                    "index": index,
                                                                    "item": "AccountTaxCodeId1",
                                                                    "value": e.value,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                                }))
                                                                dispatch(updateProjectAndTaskInExpenseList([{ "item": "TaxName1", "value": e.label, "index": index }]))
                                                            }}
                                                        /> : <a className='text-gray-800 d-block'>
                                                            {item.TaxName1 === null ? 'None' : item.TaxName1}
                                                        </a>
                                                        }
                                                    </td>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <Select
                                                            value={accountTaxCodeList.filter((x: any) => x.value === (item.AccountTaxCodeId2 === null ? 0 : item.AccountTaxCodeId2))}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            options={accountTaxCodeList}
                                                            styles={taxCodeColourStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                            menuPortalTarget={document.body}
                                                            menuPosition='fixed'
                                                            onChange={(e) => {
                                                                dispatch(updateExpenseBillingValues({
                                                                    "index": index,
                                                                    "item": "AccountTaxCodeId2",
                                                                    "value": e.value,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                                }))
                                                                dispatch(updateProjectAndTaskInExpenseList([{ "item": "TaxName2", "value": e.label, "index": index }]))
                                                            }}
                                                        /> : <a className='text-gray-800 d-block'>
                                                            {item.TaxName2 === null ? 'None' : item.TaxName2}
                                                        </a>
                                                        }
                                                    </td>
                                                    <td>
                                                        {item.IsSelected || item.IsEditable ? <input
                                                            type="text"
                                                            className="form-control inputFieldAlignment"
                                                            name="BilledExpenseAmount"
                                                            value={item.BilledExpenseAmount}
                                                           /*  onChange={(e) => dispatch(updateExpenseBillingValues({
                                                                "index": index,
                                                                "item": "BilledExpenseAmount",
                                                                "value": e.target.value
                                                            }))} */
  onBlur={(e) => {
    let val = e.target.value.trim();
    // If empty or invalid, set to 0
    if (!val || val === '') {
      const formatted = formatNumberCustomoriginal(
        cultureInfoName.toString(),
        '0',
        decimalPlaces
      );
  dispatch(updateExpenseBillingValues({
                                                                "index": index,
                                                                "item": "BilledExpenseAmount",
                                                                "value": formatted,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                            }))
    } else {
      const formatted = formatNumberCustomoriginal(
        cultureInfoName.toString(),
        val,
        decimalPlaces
      );
  dispatch(updateExpenseBillingValues({
                                                                "index": index,
                                                                "item": "BilledExpenseAmount",
                                                                "value": formatted,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                            }))
    }
  }}
  onChange={(e: any) => {
  const val = e.target.value;
  if (!validateCultureNumber(val, cultureInfoName.toString(),decimalPlaces)) {
    return;
  }
  dispatch(updateExpenseBillingValues({
                                                                "index": index,
                                                                "item": "BilledExpenseAmount",
                                                                "value": e.target.value,
                                                                    "cultureInfoName": cultureInfoName.toString()
                                                            }))
}}
                                                            style={{ width: 110 }}
                                                        /> : <a className='text-gray-800 d-block'>
                                                            {/* {item.BilledExpenseAmount.toFixed(2)} */}
                                                            {item.CurrencyCode + ' '+ FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.BilledExpenseAmount, decimalPlaces)}
                                                        </a>
                                                        }
                                                    </td>
                                                    <td>
                                                        {!item.IsSelected && <>
                                                            {!item.IsEditable && <span className="menu-icon custom-menu mb-2 cursor"
                                                                //onClick={() => { dispatch(isEditableExpenseList(item.AccountTimeExpenseBillingExpenseId)) }}
                                                                //onClick={() => { dispatch(isEditableExpenseList({item.AccountTimeExpenseBillingExpenseId || item.AccountExpenseEntryId || cultureInfoName.toString()})) }}
                                                                onClick={() => { dispatch(isEditableExpenseList({"AccountTimeExpenseBillingExpenseId": item.AccountTimeExpenseBillingExpenseId, "AccountExpenseEntryId": item.AccountExpenseEntryId, "cultureInfoName": cultureInfoName.toString()})) }}
                                                                data-tooltip-id="tooltip-Description"
                                                                data-tooltip-content=
                                                                // {"Editable"}
                                                                {getValueFromResource('Editable',dispatch, t)}
                                                                data-tooltip-place="top"
                                                            >
                                                                <i className="bi bi-pencil-square fs-6 iconColor">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>}
                                                            {item.IsEditable && <span className="menu-icon custom-menu mb-2 cursor"
                                                                onClick={() => { dispatch(isCancelExpenseList(item.AccountTimeExpenseBillingExpenseId || item.AccountExpenseEntryId)) }}
                                                                //onClick={() => { dispatch(isCancelExpenseList({"AccountTimeExpenseBillingExpenseId": index, "AccountExpenseEntryId": "BillingRate", "cultureInfoName": cultureInfoName.toString()})) }}                                                                
                                                                data-tooltip-id="tooltip-Description"
                                                                data-tooltip-content=
                                                                // {"Cancel"}
                                                                {getValueFromResource('Cancel',dispatch, t)}
                                                                data-tooltip-place="top"
                                                            >
                                                                <i className="bi bi-x-lg fs-6 iconColor">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>}
                                                        </>}
                                                        <span className="menu-icon custom-menu mb-2 cursor"
                                                            onClick={() => removeRowInExpenseBillingList(index, item.AccountTimeExpenseBillingExpenseId, item.AccountProjectId)}
                                                            data-tooltip-id="tooltip-Description"
                                                            data-tooltip-content=
                                                            // {"Delete"}
                                                            {getValueFromResource('Delete',dispatch, t)}
                                                            data-tooltip-place="top"
                                                        >
                                                            <i className="bi bi-trash fs-6 iconColor allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                                {expenseBillingCurrentItems.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                
                    <div className="card card-custom admin-card-billing-child mb-10">
                        <div className="card-header sticky-top bg-white">
                            <h3 className="card-title fw-bold headerTitle">
                                {/* {t('Invoice Description')} */}
                                {getValueFromResource('Invoice Description',dispatch, t)}
                                </h3>
                        </div>
                        <div className='card-body py-3'>
                            <div className='d-flex align-items-center flex-shrink-0'>
                                <textarea
                                    defaultValue={accountTimeExpenseBillingId === "" ? (clientInvoiceFooter === "" ? (invoiceFooter != "" ? addInvoiceFooter.join('\n') : getMasterRecord.Description) : clientInvoiceFooter) : getMasterRecord.Description}
                                    className={"form-control"}
                                    rows={4}
                                    style={{ marginRight: 8, margin: '8px 8px 8px 8px', resize: 'none' }}
                                    data-kt-element="input"
                                    placeholder=
                                    // {t('Type a message')}
                                    {getValueFromResource('Type a message',dispatch, t)}
                                    onChange={(e) => { dispatch(updateMasterTimeExpenseBillingValues({ "item": "Description", "value": e.target.value })) }}
                                >
                                </textarea>
                            </div>
                        </div>
                    </div>
                    </div>
            
            {<TaskOffCanvas obj={generalObject} />}
            <InvoicePrintViewWidget modelRef={modelRef} />
        </>
    )
}
const localColourStyles: StylesConfig = {
    control: (styles) => ({
        ...styles,
        backgroundColor: 'white',
        height: '100%',
        padding: '-1px',
        borderColor: '#EBECF0',
        width: 200
    })
}
const taxCodeColourStyles: StylesConfig = {
    control: (styles) => ({
        ...styles,
        backgroundColor: 'white',
        height: '100%',
        padding: '-1px',
        borderColor: '#EBECF0',
    })
}
export default AccountInvoiceForm